export default "__VITE_ASSET__Dokif_mu__"